(function () {
  window.__FunnelAddLock = window.__FunnelAddLock || false;

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;

      if (!form || !form.action) return;
      if (form.action.indexOf('/cart/add') === -1) return;

      if (window.__FunnelAddLock) {
        e.preventDefault();
        return;
      }

      window.__FunnelAddLock = true;
      e.preventDefault();
      e.stopPropagation();

      try {
        var btns = form.querySelectorAll('button[type="submit"], input[type="submit"]');
        btns.forEach(function (b) { b.disabled = true; });
      } catch (err) {}

      var fd = new FormData(form);
      fd.set('quantity', '1');

      fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' }
      })
        .then(function () {
          return fetch(form.action, {
            method: 'POST',
            body: fd,
            headers: { 'Accept': 'application/json' }
          });
        })
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function () {
          window.__FunnelAddLock = false;
          try {
            form.submit();
          } catch (err) {}
        });
    },
    true
  );
})();
